import { Trans } from 'react-i18next'

export const getPaymentInfoContent = ({
  hasUserPaidByCreditCardOrPaypal,
  nextBillingDateFormatted,
  userEmail,
  expiresAt
}: {
  hasUserPaidByCreditCardOrPaypal: boolean
  nextBillingDateFormatted?: string
  userEmail?: string
  expiresAt?: { formatted: string | null }
}) => {
  if (hasUserPaidByCreditCardOrPaypal) {
    return {
      heading: (
        <Trans i18nKey='checkout.confirmation.payment.info.subscription.active' />
      ),
      description: (
        <Trans
          i18nKey='checkout.confirmation.payment.info.subscription.active.description'
          values={{
            chargeDate: nextBillingDateFormatted,
            email: userEmail
          }}
        />
      )
    }
  }

  return {
    heading: (
      <Trans i18nKey='checkout.confirmation.payment.info.account.paid' />
    ),
    description: (
      <Trans
        i18nKey='checkout.confirmation.payment.info.account.paid.description'
        values={{
          expireDate: expiresAt?.formatted,
          email: userEmail
        }}
      />
    )
  }
}
